import Header from "./Header";
import SidebarTop from "./SidebarTop";
import SidebarCenter from "./SidebarCenter";
import ImportExportProgress from "./ImportExportProgress";

const layoutsComponents = {
  Header,
  SidebarTop,
  SidebarCenter,
  ImportExportProgress
};

export default layoutsComponents